(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["echo-collection-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('echo-collection-gallery')) {
    customElements.define(
      'echo-collection-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.rail = this.querySelector('scroll-carousel');
          this.previousButton = this.querySelector('[data-carousel-previous]');
          this.nextButton = this.querySelector('[data-carousel-next]');

          if (!this.rail) {
            return;
          }

          this.updateProgress = this.updateProgress.bind(this);
          this.showPrevious = () => this.scrollByCard(-1);
          this.showNext = () => this.scrollByCard(1);
          this.rail.addEventListener('scroll', this.updateProgress, { passive: true });
          this.previousButton?.addEventListener('click', this.showPrevious);
          this.nextButton?.addEventListener('click', this.showNext);
          new ResizeObserver(this.updateProgress).observe(this.rail);
          this.updateProgress();
        }

        disconnectedCallback() {
          if (this.rail) {
            this.rail.removeEventListener('scroll', this.updateProgress);
          }

          this.previousButton?.removeEventListener('click', this.showPrevious);
          this.nextButton?.removeEventListener('click', this.showNext);
        }

        scrollByCard(direction) {
          const card = this.rail.querySelector('.echo-collection-gallery__card');

          if (!card) {
            return;
          }

          const gap = Number.parseFloat(getComputedStyle(this.rail).columnGap) || 0;
          const directionFactor = document.dir === 'rtl' ? -1 : 1;
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

          this.rail.scrollBy({
            left: (card.getBoundingClientRect().width + gap) * direction * directionFactor,
            behavior,
          });
        }

        updateProgress() {
          const maximumScroll = this.rail.scrollWidth - this.rail.clientWidth;
          const progress = maximumScroll > 0 ? this.rail.scrollLeft / maximumScroll : 1;
          this.style.setProperty('--echo-gallery-progress', Math.max(0.12, progress));
          this.previousButton?.toggleAttribute('disabled', this.rail.scrollLeft <= 2);
          this.nextButton?.toggleAttribute('disabled', this.rail.scrollLeft >= maximumScroll - 2);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
